import React from "react";
import { useEffect } from 'react';

import Card from "../../../components/UI/Card/Card";

import styles from "./InfoTab.module.css";

const InfoTab = (props) => {

  useEffect(() => { props.onValidChange(true); }, []); 

  return (
    <Card className={styles.infoCard}>
      <div style={{ lineHeight: "130%" }}>
        Die Daten, die Sie in den folgenden Schritten eintragen, bleiben vorerst
        auf Ihrem Gerät und werden noch nicht an unseren Server übertragen. Wenn
        alles eingetragen wurde, können Sie im letzten Schritt unter „Senden“
        die verschlüsselte Datenübertragung an unseren Server starten.
      </div>
    </Card>
  );
};

export default InfoTab;
